import axios from 'axios';
import {message} from 'ant-design-vue';
import router from '@/router';
const service = axios.create({
    baseURL: '/api', // 设置请求的基础 URL
    withCredentials:true,
    timeout: 5000 // 请求超时时间，单位为毫秒
  });
// 请求拦截器
service.interceptors.request.use(
    config => {
      // config.headers['Content-Type'] = 'application/json';
      if ( config.headers['Content-Type']) {
        config.headers['Content-Type'] =  config.headers['Content-Type'];
        
      } else {
      //   // 默认设置 Content-Type
        config.headers['Content-Type'] = 'application/json';
      }
      console.log(' config.headers----',config.headers)
      // // 在发送请求之前做些什么，例如添加请求头
      const token = localStorage.getItem('token') || 'eyJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJvaW5BQjdES1FyVmlLVzZOaEZ4T3VONmJBbUVnIiwiaWF0IjoxNzQzMzA5MjY2LCJleHAiOjE3NDMzMTI4NjZ9.Zg_PLZFkUaZJmC5etGdcQED3x2n3ulOaciA7wtBHyxQ';
      // console.log(token)
      const loginType = localStorage.getItem('Login-Type')
      if(loginType){
        config.headers['Login-Type'] = loginType;
      }
      if (token) {
        config.headers['Authorization'] = `Bearer ${token}`;
      }
      
      return config;
    },
    error => {
      // 处理请求错误
      console.log(error); // 打印错误信息
      return Promise.reject(error);
    }
  );
  
  // 响应拦截器
  service.interceptors.response.use(
    response => {
      console.log(response)
      if(response.status == 401){
        router.push('/login')
      }
      return response.data;
    },
    error => {
      // 处理响应错误
      if(error.status == 401){
        message.error('登录失效，请重新登录～～')
        router.push('/login')
        return;
      }
      console.log('响应错误：', error.message);
      return Promise.reject(error);
    }
  );  

  export default service;